// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProgressBar{position:absolute;height:5px;width:calc(100% + 40px);top:-1px;left:-20px;display:flex;justify-content:center;align-items:center;overflow:hidden;z-index:99}.ProgressBar-filledBar{position:absolute;top:0;left:0;z-index:2;height:100%;width:100%;background:#f44d57;transition:transform .25s cubic-bezier(1,.5,.8,1)}", ""]);
// Exports
module.exports = exports;
